class InPageSearch {
  constructor (context, settings, $, debounce, MarkJS, StickySidebar, ResizeSensor) {
    // Environment variables
    this.context = context;
    this.settings = settings;
    this.$ = $;

    this.$document = this.$(document);
    this.$window = this.$(window);
    this.$html = this.$('html');
    this.$openSearchButton = this.$('.js-in-page-search-open', this.context).once();
    this.$closeSearchButton = this.$('.js-in-page-search-close', this.context).once();
    this.$inPageSearch = this.$('.js-in-page-search', this.context).once();
    this.$inPageSearchWrapper = this.$('.js-in-page-search-wrapper', this.context).once();
    this.$inPageSearchBg = this.$('.js-in-page-search-background', this.context).once();
    this.$inPageSearchInput = this.$('.js-in-page-search-input', this.context).once();
    this.$inPageSearchNav = this.$('.js-in-page-search-navigation', this.context).once();
    this.$resultsText = this.$('.js-in-page-search-results-text', this.context).once();
    this.$prevBtn = this.$('.js-in-page-search-prev', this.context).once();
    this.$nextBtn = this.$('.js-in-page-search-next', this.context).once();

    // The context where to search
    this.$content = this.$('.js-single-content', this.context);

    // jQuery object to save <mark> elements
    this.$results = '';

    // The current index of the focused element
    this.currentIndex = 0;

    this.$openSearchButton.on('click', $.proxy(this.showSearch, this));
    this.$closeSearchButton.on('click', $.proxy(this.hideSearch, this));

    this.$document.keyup((e) => {
      // Escape Key
      if (e.keyCode === 27) {
        if (this.$inPageSearchWrapper.hasClass('is-visible')) {
          this.hideSearch();
        }
      }

      // Enter Key
      if (e.keyCode === 13) {
        this.$nextBtn.trigger('click');
      }
    });

    this.$inPageSearchInput.on('input paste', (this.delay($.proxy(this.onInput, this), 300)));
    this.$nextBtn.add(this.$prevBtn).on('click', $.proxy(this.nextPrevJumpTo, this));

    if (!this.$html.hasClass('no-flexbox') && this.$inPageSearch.length) {
      this.$stickyToc = new StickySidebar('.js-in-page-search', {
        containerSelector: '.js-single-sidebar-top',
        innerWrapperSelector: '.js-in-page-search-inner',
        topSpacing: 120,
      });

      // Updating the sticky on scroll so it calculates the correct position
      this.$window.on('scroll', () => {
        if (this.$window.width() > 900) {
          this.$stickyToc.updateSticky();
        }
      });

      this.$window.on('load resize', debounce(() => {
        if (this.$window.width() <= 900 || !this.$html.hasClass('flexbox')) {
          this.$stickyToc.destroy();
        }
        else {
          this.$stickyToc.updateSticky();
        }
      }, 300));
    }
  }

  showSearch (e) {
    const $elem = this.$(e.currentTarget);

    $elem.addClass('is-clicked').attr('aria-expanded', 'true');
    this.$inPageSearchWrapper.addClass('is-visible');
    this.$inPageSearchBg.addClass('is-visible');
    this.$inPageSearchInput.focus();
  }

  hideSearch (e) {
    this.$openSearchButton.removeClass('is-clicked').attr('aria-expanded', 'false');
    this.$inPageSearchWrapper.removeClass('is-visible');
    this.$inPageSearchBg.removeClass('is-visible');
  }

  jumpTo () {
    // Top offset for the jump
    const offsetTop = 88 // Height of the fixed header, plus a little bit of
                         // space

    // The class that will be appended to the current focused element
    const currentClass = 'is-highlighted';

    if (this.$results.length) {
      let position;
      const $current = this.$results.eq(this.currentIndex);

      this.$results.removeClass(currentClass);
      if ($current.length) {
        $current.addClass(currentClass);
        position = $current.offset().top - offsetTop;
        window.scrollTo(0, position);
      }
    }
  }

  onInput (e) {
    let searchVal = this.$(e.currentTarget).val();

    this.$content.unmark({
      done: () => {
        this.$content.mark(searchVal, {
          "className": 't-light-bg',
          done: () => {

            this.$results = this.$content.find('mark');

            // Find content within accordions
            this.$results.each((index, element) => {
              let $accordionToClick = this.$(element).closest('.js-accordion-content').prev();
              if ($accordionToClick.length && !$accordionToClick.hasClass('is-clicked')) {
                $accordionToClick.trigger('click').one();
              }
            });

            this.currentIndex = 0;
            this.jumpTo();
            const noOfResults = this.$results.length;

            if (noOfResults) {
              const resultsString = `${noOfResults} result${noOfResults === 1 ? "" : "s"}`
              this.$inPageSearchNav.addClass('is-visible').removeClass('has-no-results');
              this.$resultsText.text(`${resultsString}`);
            }
            else {
              this.$inPageSearchNav.addClass('has-no-results');
              this.$resultsText.text('No results');
            }
          }
        });
      }
    });
  }

  nextPrevJumpTo (e) {
    const $elem = this.$(e.target);

    if (this.$results.length) {
      this.currentIndex += $elem.is(this.$prevBtn) ? -1 : 1;

      if (this.currentIndex < 0) {
        this.currentIndex = this.$results.length - 1;
      }

      if (this.currentIndex > this.$results.length - 1) {
        this.currentIndex = 0;
      }

      this.jumpTo();
    }
  }

  // Function to delay text input so it only fires after a certain amount of
  // time
  // https://stackoverflow.com/questions/1909441/how-to-delay-the-keyup-handler-until-the-user-stops-typing
  delay (fn, ms) {
    let timer = 0
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
  }
}

export default InPageSearch;